import { render, staticRenderFns } from "./DashboardWidgetTable.vue?vue&type=template&id=404e37b2&scoped=true"
import script from "./DashboardWidgetTable.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetTable.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetTable.vue?vue&type=style&index=0&id=404e37b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404e37b2",
  null
  
)

export default component.exports